import { cache } from '@/container/apollo-client/cache';
import { usePhoneStore } from '../../store/phone.store';
import {
  CallQueueCallStatusEnum,
  GetCallQueueCallsCountDocument,
  GetCallQueueCallsCountQuery,
  GetCallQueueCallsCountQueryVariables,
} from '@/types/generated/graphql';

export function hasWaitingQueuedCalls() {
  const data = cache.readQuery<GetCallQueueCallsCountQuery, GetCallQueueCallsCountQueryVariables>({
    query: GetCallQueueCallsCountDocument,
    variables: { status: CallQueueCallStatusEnum.waiting },
  });

  return (data?.getCallQueueCallsCount?.data?.count ?? 0) > 0;
}

export function shouldAutoOpenQueuePanel({
  isWaiting,
  isNewCaller,
  waitingCount,
}: {
  isWaiting: boolean;
  isNewCaller: boolean;
  waitingCount: number;
}) {
  return isWaiting && isNewCaller && waitingCount === 1;
}

export function revealQueuePanel() {
  const { isOpen, isPopupView, openDialer, setPopupView, openQueuePanel } = usePhoneStore.getState();

  if (!isOpen) openDialer();
  else if (isPopupView) setPopupView(false);

  openQueuePanel();
}
